import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ChoferEADForm } from "./form";
const ChoferEADFormRx = componentToRx(ChoferEADForm);
type Entity = models.ChoferEAD;
const resource = resources.ChoferEAD;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value?: Entity;
}
class ChoferEADEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    idStr = (props: Props, state: State) => this.props.match.params.id;
    id = createSelectorRx(this.idStr, id => id == "new" ? "new" : Number.parseInt(id));

    valueFromResource = createSelectorRx(this.id, id => id == "new" ? toObservable({} as Entity) : observeResource(resource.get, id));
    valueFromState = (props: Props, state: State) => state.value;
    value = createSelectorRx(this.valueFromState, this.valueFromResource, (state, resource) => state || resource);

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id(this.props, this.state);
        const func = id == "new" ? resource.add : resource.update;
        const value = await nextToPromise(this.value(this.props, this.state));
        await func(value);
        history.go("../");
    }

    render() {
        const value = this.value(this.props, this.state);
        const id = this.id(this.props, this.state);
        return <ChoferEADFormRx
            value={value}
            onChange={this.onChange}
            nuevo={id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const ChoferEADEdit = withRouter(ChoferEADEditComp);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/choferEAD/edit/edit.tsx